<template>
  <el-dialog :title="title" :visible.sync="dialogVisibleAllocation" width="50%">
    <div >
      <el-form :model="queryParams"  label-width="60px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="查询项：" label-width="60px">
              <el-select v-model="queryParams.name" placeholder="请选择">
                <el-option label="姓名" value="staffName"></el-option>
                <el-option label="部门名称" value="orgName"></el-option>
                <el-option label="职位名称" value="jobName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label-width="10px">
              <el-input v-model="params.value" placeholder="请输入关键字"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
             <el-form-item label-width="10px">
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button type @click="searchReset">重置</el-button>
             </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        ref="allocationTableRef"
        :data="allocationTable"
        tooltip-effect="dark"
        :header-cell-style="tableHeader"
        highlight-current-row
        @current-change="handleSelectionChange"
        height="360"
        border
       >
        <el-table-column prop="orgName" label="部门"></el-table-column>
        <el-table-column prop="jobName" label="职务"></el-table-column>
        <el-table-column prop="staffName" label="姓名"></el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onAgainConfirm">确 定</el-button>
      <el-button @click="dialogVisibleAllocation = false">取 消</el-button>
    </span>
    <el-dialog title="选择负责员工" :visible.sync="dialogVisibleAddAgencySet" width="30%" append-to-body>
      <div style='padding-left:30px'>确认{{suName}}由{{staffName}}负责？</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onSelect">确 定</el-button>
        <el-button @click="dialogVisibleAddAgencySet = false">取 消</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>
<script>
import { queryAllHasSalePowerStaffInfo } from '@/api/system/rightsManagement'
import { updateByStaffUsename } from '@/api/supplier/supplierManage'
export default {
  data () {
    return {
      dialogVisibleAllocation: false,
      dialogVisibleAddAgencySet: false,
      title: '分配负责人',
      queryParams: {},
      params: {},
      allocationTable: [],
      num: 0,
      arrId: [], // 接收客户转移列表数据
      checkList: {}, // 选择的列表数据
      parentParams: {},
      suName: '', // 供应商名字
      staffName: '' // 员工名称
    }
  },
  created () {},
  methods: {
    onInitial (row) {
      this.parentParams = row
      this.dialogVisibleAllocation = true
      this.title = '你选择了' + row.suName + ',请选择负责的员工'
      this.getList()
    },
    // 列表
    getList () {
      const params = {
        criteriaVoList: this.$queryParams(this.queryParams, this.params),
        queryPageName: ''
      }
      queryAllHasSalePowerStaffInfo(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.allocationTable = res.data.obj
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 搜索
    onSearch () {
      this.getList()
    },
    // 重置
    searchReset () {
      this.queryParams = {}
      this.params = ''
      this.getList()
    },
    // 确定
    onAgainConfirm () {
      if (
        this.checkList === undefined ||
        this.checkList.staffName === undefined
      ) {
        this.$message.error('请选中移交员工')
      } else {
        this.suName = this.parentParams.suName
        this.staffName = this.checkList.staffName
        this.dialogVisibleAddAgencySet = true
      }
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 选择负责员工
    onSelect () {
      updateByStaffUsename(this.checkList.id, this.parentParams.suId)
        .then((res) => {
          if (res.data.code === 200) {
            this.dialogVisibleAddAgencySet = false
            this.dialogVisibleAllocation = false
            this.$emit('onRefresh')
            this.$message.success('设置成功!')
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 列表数据选中
    handleSelectionChange (row) {
      if (row.length > 1) {
        this.$refs.allocationTableRef.clearSelection()
      } else {
        this.checkList = row
      }
    },
    // 点击空白处选中
    handleRowClick (row, column, event) {
      this.$refs.allocationTableRef.toggleRowSelection(row)
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>
